import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AuditType, Product} from "../../../../../store/state/order.state";
import {ChangeSet} from "../../../history/order-history.model";

@Component({
    selector: 'transfer-questions-details',
    templateUrl: './transfer-questions-details.template.html',
    styleUrls: ['./transfer-questions-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TransferQuestionsDetailsComponent {

	readonly RANDOM_NUMBER: number = Math.random();

	@Input() product: Product;
	@Input() changeSet: ChangeSet;

	get hasCertificate(): boolean {
		return this.product.standard.hasCertificate;
	}

	get currentCertificationBody(): string {
		return this.product.standard.otherCbName;
	}

	get currentCertificationLastAuditEvent(): AuditType {
		return this.product.transferQuestions.lastAuditEvent;
	}

	standardName(): string {
		return this.product.standard.name.toLowerCase();
	}

	isOtherCbChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].otherCB;
	}

	isLastAuditEventChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].lastAuditEvent;
	}
}
